var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('ButtonMiniAction', _vm._b({
    staticClass: "nav_button",
    class: {
      width_auto: _vm.widthAuto
    },
    attrs: {
      "disabled": _vm.disabled,
      "icon": _vm.icon,
      "icon-color": _vm.computedIconColor,
      "tooltip": _vm.tooltip,
      "tooltip-position": _vm.tooltipPosition
    }
  }, 'ButtonMiniAction', _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };